import { useState, useEffect } from 'react';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { Property } from '../types/user';
import { MonthlyStats } from '../types/property';
import { getPropertyById } from '../services/properties';
import { useAuthStore } from '../store/authStore';
import { PropertyReport } from '../components/PropertyReport';
import { MonthlyDataManager } from '../components/property/MonthlyDataManager';
import { getMonthlyStats } from '../services/stats';
import { Card } from '../components/ui/Card';
import toast from 'react-hot-toast';

export const OwnerDashboard = () => {
  const [property, setProperty] = useState<Property | null>(null);
  const [monthlyStats, setMonthlyStats] = useState<MonthlyStats[]>([]);
  const [loading, setLoading] = useState(true);
  const user = useAuthStore(state => state.user);

  const fetchData = async () => {
    if (!user?.propertyId) {
      setLoading(false);
      return;
    }

    try {
      const [propertyData, statsData] = await Promise.all([
        getPropertyById(user.propertyId),
        getMonthlyStats(user.propertyId)
      ]);

      if (!propertyData) {
        throw new Error('Propiedad no encontrada');
      }

      setProperty(propertyData);
      setMonthlyStats(statsData);
    } catch (error) {
      console.error('Error fetching property:', error);
      toast.error('Error al cargar los datos de la propiedad');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user?.propertyId]);

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500" />
        </div>
      </DashboardLayout>
    );
  }

  if (!property) {
    return (
      <DashboardLayout>
        <div className="text-center text-gray-500">
          No tienes ninguna propiedad asignada
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <PropertyReport property={property} monthlyStats={monthlyStats} />
        
        <Card>
          <MonthlyDataManager
            propertyId={property.id}
            monthlyStats={monthlyStats}
            onDataChange={fetchData}
          />
        </Card>
      </div>
    </DashboardLayout>
  );
};